import { render, staticRenderFns } from "./InformationCertification.vue?vue&type=template&id=4d219adc&scoped=true"
import script from "./InformationCertification.vue?vue&type=script&lang=js"
export * from "./InformationCertification.vue?vue&type=script&lang=js"
import style0 from "./InformationCertification.vue?vue&type=style&index=0&id=4d219adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d219adc",
  null
  
)

export default component.exports